<template>
  <div>
    <div
      v-for="field in fields"
      :key="field.id"
      class="bg-gray-100 rounded mb-1 py-2 px-3 flex justify-between"
    >
      <div>
        {{ field.name }}
        <span
          v-if="!field.used"
          class="text-gray-400 text-sm ml-2"
        >(niet ingeschakeld)</span>
      </div>
      <div v-if="!field.is_locked" class="flex items-center">
        <DeleteConfirmButton
          v-if="field.used"
          class="flex items-center rounded p-1 hover:bg-gray-300"
          confirm-text="Ja, uitschakelen"
          :message="`Weet je zeker dat je ${field.name} niet meer wilt gebruiken?`"
          @confirm="toggleField(field)"
        >
          <BaseIcon name="minus" size="16" />
        </DeleteConfirmButton>
        <button
          v-else
          class="flex items-center rounded p-1 hover:bg-gray-300"
          @click="toggleField(field)"
        >
          <BaseIcon name="plus" size="16" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { patch } from "@/api.js";
import DeleteConfirmButton from "@/components/DeleteConfirmButton";

export default {
  props: {
    fields: Array
  },

  components: {
    DeleteConfirmButton
  },

  methods: {
    toggleField(field) {
      let used = !field.used;

      patch(`/fields/update/${field.id}`, { used }).then(response => {
        this.$store.commit("SET_SETTINGS", response.data);
        let message = used
          ? `Veld ${field.name} ingeschakeld!`
          : `Veld ${field.name} uitgeschakeld!`;
        this.$store.commit("FLASH_ADD", { message });
      });
    }
  }
};
</script>